import React from 'react'
import { connect } from 'react-redux'
import $ from 'jquery'

import { clearNoDataError } from '../../GlobalStateContainer/actions'
import { reprocessImport } from '../UnprocessedRecords/actions'

import { fetchJobsError, fetchJobsUpdatedList, fetchJob, fetchJobFile, createJob, errorJob } from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './Jobs.css'
import UnprocessedRecords from '../UnprocessedRecords/UnprocessedRecords';

var Spinner = require('react-spinkit');

let chkReturn = 0;

class Jobs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            reprocessmsg: false
        };

        this.selectPanel = this.selectPanel.bind(this);
        this.selectJob = this.selectJob.bind(this);

        this.refresh = this.refresh.bind(this);

        this.create = this.create.bind(this);

        this.newsearch = this.newsearch.bind(this);

        this.getJobFile = this.getJobFile.bind(this);

        this.showImportSummary = this.showImportSummary.bind(this);
        this.hideImportSummary = this.hideImportSummary.bind(this);

        this.loadMore = this.loadMore.bind(this);

        this.fetchJobsErrorClear = this.fetchJobsErrorClear.bind(this);
        this.errorJobClear = this.errorJobClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.reProcessMsg = this.reProcessMsg.bind(this);
        this.reProcessMsgVerify = this.reProcessMsgVerify.bind(this);
        this.clearReprocessMsg = this.clearReprocessMsg.bind(this);
    }

    componentDidMount() {
        var _this = this

        chkReturn = setInterval(function () {
            if (_this.props.jobs.fetched || _this.props.jobs.error) {
                if (_this.props.jobs.fetched) {
                    $('div#Retrieve').css('display', 'block')
                    $('li[panel="Retrieve"]').addClass('selected')
                }

                clearInterval(chkReturn)
                chkReturn = 0

                if (window.location.pathname.toLowerCase() !== '/prod-mgmt/jobslist') {
                    let pathParts = window.location.pathname.split('/')
                    let id = pathParts[pathParts.length - 1]

                    _this.setState({ page: 1, job: 'JobID' })

                    $('select#jobsel').val("JobID")
                    $('input#newsearch').val(id)

                    fetchJob.bind(_this)(id)
                }
            }
        }, 100)
    }

    fetchJobsErrorClear() {
        this.props.dispatch(fetchJobsError);
    }

    errorJobClear() {
        this.props.dispatch(errorJob);
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    selectPanel(e) {
        if (this.props.jobs.fetching || this.props.jobs.updating) return

        $('div.panelFrame').css('display', 'none')
        $('li.jobview').removeClass("selected")

        e.currentTarget.className = "jobview selected"
        $('div#' + e.currentTarget.attributes["panel"].value).css('display', 'block')
    }

    selectJob(e) {
        this.setState({ page: 1, job: e.target.value })

        if (e.target.value == 'JobID') {
            setTimeout(function () {
                $('input#newsearch').val('')
                $('input#newsearch').addClass('error')

                $('button#refresh').attr('disabled', 'disabled')
            }, 100)
        }
        else {
            $('button#refresh').removeAttr('disabled')

            fetchJobsUpdatedList.bind(this)(
                {
                    jobType: e.target.value == 'All' ? null : e.target.value,
                    pageNumber: 1
                }
            )
        }
    }

    newsearch(e) {
        if (this.props.jobs.fetching || this.props.jobs.updating) return

        if (e.target.value.length) {
            e.target.className = ''
            $('button#refresh').removeAttr('disabled')
        }
        else {
            e.target.className = 'error'
            $('button#refresh').attr('disabled', 'disabled')
        }
    }

    refresh() {
        if (this.props.jobs.fetching || this.props.jobs.updating) return

        if (this.state.job == 'JobID')
            fetchJob.bind(this)($('input#newsearch').val())
        else
            fetchJobsUpdatedList.bind(this)(
                {
                    jobType: this.state.job == 'All' ? null : this.state.job,
                    pageNumber: this.state.page
                }
            )
    }
      
    create() {
        createJob.bind(this)({ jobType: $('select#jobtype').val() })
    }

    getJobFile(job) {
        fetchJobFile.bind(this)(job);
    }

    getFileDescription(job) {
        if (job.jobType == "4") {
            var input = JSON.parse(job.input);
            if (input.ListTypeFilter == "1") {
                return "Missing Template";
            } else if (input.ListTypeFilter == "2") {
                if (input.UnpublishedTemplateFilter && input.UnpublishedTemplateFilter != "0") {
                    return "Missing Supplemental - Unpublished Template ID " + input.UnpublishedTemplateFilter;
                } else {
                    return "Missing Supplemental - Published Template ID " + input.PublishedTemplateFilter;
                }
            }
        } else if (job.jobType == "5") {
            return job.input ? job.input.substring(job.input.lastIndexOf("\\") + 1) : "";
        }

        return "";
    }

    reProcessMsg(e) {
        reprocessImport.bind(this)(this.props.users.user, e.target.attributes.job.value)

        chkReturn = setInterval(this.reProcessMsgVerify, 100);
    }

    reProcessMsgVerify() {
        if (this.props.unprocessedRecords.fetched || this.props.unprocessedRecords.error) {
            if (this.props.unprocessedRecords.fetched)   {
                this.setState({ reprocessmsg: true });
            }

            $('#body').html(this.props.unprocessedRecords.reprocessMsg)

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    clearReprocessMsg() {
        this.setState({ reprocessmsg: false })
    }

    showImportSummary(job) {
        var modal = document.getElementById("importSummaryModal");

        //var tbody = document.getElementById("importSummaryErrorTable").getElementsByTagName("tbody")[0];
        var list = document.getElementById("importSummaryErrorList");

        var output;
        try {
            output = JSON.parse(job.output);
        } catch (e) {
            output = {
                NumberOfRecordsLoadedSuccessfully: "?",
                ErrorMessages: [
                    job.output.replace("\n", "<br />")
                ]
            };
        }

        document.getElementById("importSummaryRecordsLoaded").innerHTML = output["NumberOfRecordsLoadedSuccessfully"];
        for (var i = 0; i < output["ErrorMessages"].length; i++) {
            var listrow = list.insertRow();
            var listcell = listrow.insertCell();
            listcell.innerHTML = output["ErrorMessages"][i];
        }

        modal.style.display = "block";
    }

    hideImportSummary() {
        var modal = document.getElementById("importSummaryModal");

        modal.style.display = "none";
        //modal.getElementsByTagName("tbody")[0].innerHTML = "";
        document.getElementById("importSummaryErrorList").innerHTML = "";
    }

    loadMore() {
        if (this.props.jobs.fetching || this.props.jobs.updating) return

        let currPage = this.state.page + 1;

        this.setState({ page: currPage });

        fetchJobsUpdatedList.bind(this)(
            {
                pageNumber: currPage,
                jobType: this.state.job == 'All' ? null : this.state.job
            }
        );
    }

    getJobTypeString(type) {
        switch (type) {
            case 1: return "AS400";
            case 2: return "Template Preprocessor";
            case 3: return "User Import";
            case 4: return "Supplemental Export";
            case 5: return "Supplemental Import";
            case 6: return "Delete Supplemental";
            default: return type;
        }
    }

    render() {
        return (
            <div className="jobs col-xs-12">
                <CommError error={this.props.jobs.error} onClose={this.fetchJobsErrorClear} />

                <ConfirmModal open={this.props.jobs.noData} heading={"Background Jobs"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />
                <ConfirmModal msglink open={this.state.reprocessmsg} heading={"Unprocessed Records"} notifyOnly={true} onYes={this.clearReprocessMsg} />

                <div className="headWrapper">
                    <div className="product">
                        <h1>Background Jobs</h1>
                    </div>
                </div>
                <div className="tableWrapper">
                    {
                        this.props.jobs.fetching || this.props.jobs.updating ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }

                    <ul>
                        <li className="jobview" panel="Retrieve" onClick={this.selectPanel}>Retrieve a Job Status</li>
                        <li className="jobview" panel="Create" onClick={this.selectPanel}>Create a new Job</li>
                    </ul>

                    <div className="panelFrame" id="Retrieve">
                        <div className="header">
                            <div className="search">
                                <span>Select Jobs to Retrieve: </span>
                                {
                                    this.props.jobs.fetching || this.props.jobs.updating ?
                                        <select id="jobsel" disabled>
                                            <option value="All">All</option>
                                            <option value="JobID">Job ID</option>
                                            <option value="AS400Import">AS400</option>
                                            <option value="TemplatePreprocessor">Template Preprocessor</option>
                                            <option value="LdapUserImport">User Import</option>
                                            <option value="UnprocessedRecordsExport">Supplemental Export</option>
                                            <option value="UnprocessedRecordsImport">Supplemental Import</option>
                                        </select>
                                    :
                                        <select id="jobsel" onChange={this.selectJob}>
                                            <option value="All">All</option>
                                            <option value="JobID">Job ID</option>
                                            <option value="AS400Import">AS400</option>
                                            <option value="TemplatePreprocessor">Template Preprocessor</option>
                                            <option value="LdapUserImport">User Import</option>
                                            <option value="UnprocessedRecordsExport">Supplemental Export</option>
                                            <option value="UnprocessedRecordsImport">Supplemental Import</option>
                                        </select>
                                }

                                {
                                    this.state.job == 'JobID' ?
                                        <input id="newsearch" onChange={this.newsearch} />
                                    :
                                        null
                                }

                                <button id="refresh" className="btn btn-block btn-primary" onClick={this.refresh}>Retrieve/Refresh</button>
                            </div>

                            <div className="pagination">
                                <p>{this.props.jobs.results} Results (Viewing 1-{this.props.jobs.updatedList.length > this.props.jobs.results ? this.props.jobs.results : this.props.jobs.updatedList.length} of {this.props.jobs.results})</p>
                            </div>
                        </div>

                        <table className="lists table table-striped">
                            <thead>
                                <tr className="head">
                                    <th>ID</th>
                                    <th>JobType</th>
                                    <th>Status</th>
                                    <th>Completion %</th>
                                    <th>InitiatedBy</th>
                                    <th>StartDateTime</th>
                                    <th>EndDateTime</th>
                                    <th>Duration</th>
                                    <th>File Description</th>
                                    <th>File</th>
                                    <th>File Summary</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.props.jobs.updatedList.length ?
                                        this.props.jobs.updatedList.map((srch, index) => {
                                            return <tr className="body" key={index} id={srch.importJobId}>
                                                <td>{srch.importJobId}</td>
                                                <td>{this.getJobTypeString(srch.jobType)}</td>
                                                <td>
                                                    {
                                                         (srch.jobType == 5 && srch.statusMessage == "Errored") ?
                                                            "Complete w/ Errors"
                                                         :
                                                            srch.statusMessage
                                                    }
                                                </td>
                                                <td>{srch.completionPercent}</td>
                                                <td>{srch.initiatedBy}</td>
                                                <td>{srch.jobStartDateTimeDisplay}</td>
                                                <td>{srch.jobEndDateTimeDisplay}</td>
                                                <td>{srch.jobDuration}</td>
                                                <td>{this.getFileDescription(srch)}</td>
                                                {((srch.jobType == 4 && srch.statusMessage == "Completed")) ?
                                                    <td className="action" job={srch.importJobId} onClick={() => this.getJobFile(srch)}>Download</td>
                                                :
                                                    srch.jobType == 5 ?
                                                        <td>
                                                            <p className="action" job={srch.importJobId} onClick={() => this.getJobFile(srch)}>Download</p>
                                                            <p className="action" job={srch.importJobId} onClick={this.reProcessMsg}>Reprocess</p>
                                                        </td>
                                                    :
                                                        <td></td>
                                                }
                                                {((srch.statusMessage.includes("Complete") || srch.statusMessage == "Errored") && srch.jobType == 5) ?
                                                    <td className="action" job={srch.importJobId} onClick={() => this.showImportSummary(srch)}>View</td>
                                                :
                                                    <td></td>
                                                }
                                            </tr>
                                        })
                                    : null
                                }
                            </tbody>
                        </table>
                        {
                            this.props.jobs.pages * 50 > this.state.page * 50 ?
                                <button className="btn btn-block" onClick={this.loadMore}>Load More</button>
                            :
                                null
                        }
                    </div>

                    <div className="panelFrame" id="Create">
                        <CommError error={this.props.jobs.errorUpdated} onClose={this.errorJobClear} />

                        <div className="header">
                            <div className="search">
                                <span>Select Job Type: </span>
                                <select id="jobtype">
                                    <option value="1">AS400</option>
                                    <option value="2">Template Preprocessor</option>
                                    <option value="3">User Import</option>
                                </select>

                                <button id="create" className="btn btn-block btn-primary" onClick={this.create}>Create</button>
                            </div>
                        </div>

                        <table className="lists table table-striped">
                            <thead>
                                <tr className="head">
                                    <th>ID</th>
                                    <th>JobType</th>
                                    <th>Status</th>
                                    <th>Completion %</th>
                                    <th>InitiatedBy</th>
                                    <th>StartDateTime</th>
                                    <th>EndDateTime</th>
                                    <th>Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.props.jobs.createdList.length ?
                                        this.props.jobs.createdList.map((srch, index) => {
                                            return <tr className="body" key={index}>
                                                <td>{srch.importJobId}</td>
                                                <td>{srch.jobType}</td>
                                                <td>{srch.statusMessage}</td>
                                                <td>{srch.completionPercent}</td>
                                                <td>{srch.initiatedBy}</td>
                                                <td>{srch.jobStartDateTimeDisplay}</td>
                                                <td>{srch.jobEndDateTimeDisplay}</td>
                                                <td>{srch.jobDuration}</td>
                                            </tr>
                                        })
                                    : null
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div id="importSummaryModal" class="modal" tabIndex="-1" role="dialog" onClick={this.hideImportSummary}>
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div id="modal-header" class="modal-header">
                                <button type="button" class="close" aria-label="Close" onClick={this.hideImportSummary}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h4 class="modal-title">File Summary</h4>
                            </div>
                            <div id="modal-body" class="modal-body">
                                <h5># of Records Loaded Successfully: <span id="importSummaryRecordsLoaded"></span></h5>
                                <div id="importSummaryErrors">
                                    <h5>Error Records:</h5>
                                    <div>
                                        <table class="table table-striped lists" id="importSummaryErrorList"></table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    jobs: state.jobs,
    users: state.users,
    unprocessedRecords: state.unprocessed_records
});

export default connect(mapStateToProps)(Jobs)